import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = {
  key: 1,
  id: "wizard-form-row",
  style: {"margin-top":"-25px"},
  class: "row justify-content-center"
}
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = {
  key: 2,
  id: "results-display-row",
  class: "row justify-content-center"
}
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-warning text-warning mb-4",
  role: "alert"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "card custom-shadow rounded-3 bg-hero-secondary border mb-4" }
const _hoisted_9 = { class: "card-body p-4 text-white" }
const _hoisted_10 = { class: "d-lg-flex justify-content-lg-between align-items-lg-center" }
const _hoisted_11 = {
  class: "text-center text-lg-start mb-3 mb-lg-0",
  style: {"max-width":"600px"}
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "d-flex justify-content-center justify-content-lg-end gap-3 flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_WelcomeForfettario = _resolveComponent("WelcomeForfettario")!
  const _component_FormWizard = _resolveComponent("FormWizard")!
  const _component_TaxResults = _resolveComponent("TaxResults")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.t('ff.page.title', 'Calcola la tua rata'),
      subTitle: _ctx.t('ff.page.subtitle', 'Forms')
    }, null, 8, ["pageTitle", "subTitle"]),
    (!_ctx.showResultsArea)
      ? (_openBlock(), _createBlock(_component_WelcomeForfettario, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.showResultsArea)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormWizard, {
              onSubmitWizard: _ctx.handleFormSubmission,
              "initial-data": _ctx.wizardFormData
            }, null, 8, ["onSubmitWizard", "initial-data"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showAlert)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-error-warning-line fs-18 me-1" }, null, -1)),
                  _createElementVNode("span", { innerHTML: _ctx.alertMessage }, null, 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TaxResults, {
              results: _ctx.apiResults,
              liquidityResults: _ctx.liquidityApiResults,
              contributionRegime: _ctx.wizardFormData.contributionRegime,
              formData: _ctx.wizardFormData
            }, null, 8, ["results", "liquidityResults", "contributionRegime", "formData"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h3", {
                      class: "mb-0 fw-semibold text-white",
                      innerHTML: _ctx.t('ff.results.final_section.title', 'Il tuo piano è già al sicuro.')
                    }, null, 8, _hoisted_12),
                    _createElementVNode("span", {
                      class: "d-block text-white",
                      innerHTML: _ctx.t('ff.results.final_section.text', 'Ottima notizia! Questa simulazione è stata salvata automaticamente nella tua dashboard. Puoi tornare qui in ogni momento per modificarla o creare nuovi scenari.')
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/dashboard",
                      class: "btn btn-primary py-3 px-4 fw-semibold"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('ff.results.final_section.cta_button', 'Dashboard')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editData && _ctx.editData(...args))),
                      class: "btn btn-outline-primary bg-white text-primary py-3 px-4 fw-semibold border-0"
                    }, _toDisplayString(_ctx.t('ff.button.edit', 'Modifica')), 1)
                  ])
                ])
              ])
            ])
          ])
        ]))
  ]))
}